// extracted by mini-css-extract-plugin
export var callCard = "_o3-0";
export var callMessageButton = "_o3-1";
export var helpIcon = "_o3-3";
export var helpIconContainer = "_o3-4";
export var verticalDivider = "_o3-2";